import { useContext, useEffect, useState } from 'react'
import { ConfiguratorContext } from '../../Contexts/Configuration'
import PlanLayout from '../../Layouts/PlanLayout/PlanLayout'
import Plan from '../../Models/Plan'
import API from '../../Services/API'
import { NavigationNode } from '../../Services/Navigation'
import { validateAlphaString, validateIban } from '../../Services/Validation'
import ViewType from '../../Types/ViewType'
import './BankPageView.css'

const BankPageView = () =>
{
	let context = useContext(ConfiguratorContext)

	let [iban, setIban] = useState(context.iban)
	let [ibanError, setIbanError] = useState("")
	let [bank, setBank] = useState(context.bank)
	let [bankError, setBankError] = useState("")
	let [place, setPlace] = useState(context.place)
	let [placeError, setPlaceError] = useState("")
	let [plan, setPlan] = useState<Plan | undefined>(undefined)

	context.validateBankPageView = () =>
	{
		let validIban = validateIban(iban ?? "")
		setIbanError(validIban ? "" : "Inserisci un iban valido")
		context.iban = iban?.trim()

		let validBank = validateAlphaString(bank ?? "")
		setBankError(validBank ? "" : "Inserisci la banca")
		context.bank = bank?.trim()

		let validPlace = validateAlphaString(place ?? "")
		setPlaceError(validPlace ? "" : "Inserisci la filiale")
		context.place = place?.trim()

		return validIban && validBank && validPlace
	}

	useEffect(() => {
		(async () => {
			let m = []
			for (var d of context.options ?? []) {
				m.push({ id: d.parentId, products: [...d.selection].filter(x => x[1]).map(x => x[0]) })
			}
				let p = await API.getPlanAsync(context.selectedOffer!.id, {
					number_portability: context.keepNumber,
					wifi_consultancy: context.wifiCoverageCheck,
					payment_type: context.paymentType != null ? context.paymentType.name : '',
					payment_mode: context.paymentMode != undefined ? context.paymentMode.name: '',
					customer_type_id: context.isHomeUse ? 1 : 2,
					data: m
				})
				if (p.success) {
					setPlan(p.data)
				}
		})()
		return () => { }
	}, [context.keepNumber, context.paymentType, context.wifiCoverageCheck, context.selectedOffer, context.options])

	return (
		<PlanLayout plan={plan}>
			<div className="bank-page-main">
				<div className='bank-page-title'>Dati bancari</div>
				<div className='bank-page-question-wrapper'>
					<div className="bank-page-label-question">Inserisci il tuo iban</div>
					<input onChange={i => setIban(i.target.value)} value={iban} className="bank-page-input" />
					<div className='label-error'>{ibanError}</div>
				</div>
				<div className='bank-page-question-wrapper'>
					<div className="bank-page-label-question">Nome banca</div>
					<input onChange={b => setBank(b.target.value)} value={bank} className="bank-page-input" />
					<div className='label-error'>{bankError}</div>
				</div>
				<div className='bank-page-question-wrapper'>
					<div className="bank-page-label-question">Filiale</div>
					<input onChange={p => setPlace(p.target.value)} value={place} className="bank-page-input" />
					<div className='label-error'>{placeError}</div>
				</div>
			</div>
		</PlanLayout>
	)
}

const BankPageNode: NavigationNode = {
	next: () => ViewType.documentsUpload,
	previous: () => ViewType.paymentType,
	content: () => <BankPageView />,
	percentage: 90
}

export default BankPageNode
